const copy = {
  preChat: {
    headerText: "How can I help?",
    secondaryHeaderText: "Ask our Support Co-Pilot!",
    subText: "Need help getting started?",
    anchorText: "View quick start guide",
  },
  vpnLoading: {
    headerText: "Support Co-Pilot is trying to connect",
    subText: "Please ensure you are connected to the VPN, then try again.",
  },
};

export default copy;
